import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      '& $headerWrapper': {
        marginBottom: MIDDLE_MARGIN,
        [theme.breakpoints.up('md')]: {
          MIDDLE_MARGIN,
        },
      },
      '& $headerContainer': {
        paddingTop: 130,
        paddingBottom: LARGE_MARGIN,
        [theme.breakpoints.up('md')]: {
          paddingTop: 200,
          paddingBottom: LARGE_MARGIN,
        },
      },
      '& $headerTitle': {
        marginBottom: 0,
        textAlign: 'left',
      },
    },
    headerWrapper: {},
    headerContainer: {},
    headerTitle: {},
    headerDescription: {
      marginTop: SMALL_MARGIN,
      color: colorsPalette.gray,
      lineHeight: 1.5,
      fontSize: 18,
      maxWidth: 794,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        marginTop: MIDDLE_MARGIN,
      },
    },
  }),
);

export default useStyles;
